import {gql} from "@apollo/client";

export const ADD_STRIPE_SUBSCRIPTION = gql`
    mutation add_stripe_subscription($customerId: String, $priceId: String!) {
        addStripeSubscription(customerId: $customerId, priceId: $priceId) {
            result {
                status
                message
                subscriptionId
                customerId
                clientSecret
                trial
            }
        }
    }
`

export const ADD_SETUP_INTENT = gql`
    mutation add_setup_intent($customerId: String, $priceId: String!) {
        addSetupIntent(customerId: $customerId, priceId: $priceId) {
            result {
                status
                message
                clientSecret
                customerId
            }
        }
    }
`

export const GET_STRIPE_PRODUCTS = gql`
    query get_stripe_products {
        getStripeProducts {
            title
            price
            description
            # billing
            interval
            priceId
        }
    }
`